import { connect } from 'react-redux';
import {
    activeMemberTypeChange,
    cleanMessages,
    closeShelfCalled,
    confirmChangesAccepted,
    confirmChangesRejected,
    createNewMember,
    deleteMemberClicked,
    managePermissionsCalled,
    managePermissionsFinished,
    resendInvitation,
    wizardActionTypeChanged,
} from './actions';
import TeamManagement from './page';
import { getTeamManagementPage } from './selectors';

const mapStateToProps = state => {
    return getTeamManagementPage(state);
};

const mapDispatchToProps = dispatch => {
    return {
        onDeleteMember: (...args) => {
            dispatch(deleteMemberClicked(...args));
        },
        onDeleteBtnClicked: (...args) => {
            dispatch(cleanMessages(...args));
        },
        onResendInvitation: (...args) => {
            dispatch(resendInvitation(...args));
        },
        onManagePermissions: (...args) => {
            dispatch(cleanMessages());
            dispatch(managePermissionsCalled(...args));
        },
        onCreateNewMember: (...args) => {
            dispatch(cleanMessages());
            dispatch(createNewMember(...args));
        },
        onManagePermissionsFinished: (...args) => {
            dispatch(managePermissionsFinished(...args));
        },
        onCloseShelf: (...args) => {
            dispatch(closeShelfCalled(...args));
        },
        onWizardActionTypeChanged: (...args) => {
            dispatch(wizardActionTypeChanged(...args));
        },
        onActiveMemberTypeChange: activeMemberType => {
            dispatch(cleanMessages());
            dispatch(activeMemberTypeChange(activeMemberType));
        },
        onConfirmChangesAccepted: () => dispatch(confirmChangesAccepted()),
        onConfirmChangesRejected: () => dispatch(confirmChangesRejected()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamManagement);
